import { render, staticRenderFns } from "./tablaTipodedocumentos.vue?vue&type=template&id=5028990a&scoped=true&"
import script from "./tablaTipodedocumentos.vue?vue&type=script&lang=js&"
export * from "./tablaTipodedocumentos.vue?vue&type=script&lang=js&"
import style0 from "./tablaTipodedocumentos.vue?vue&type=style&index=0&id=5028990a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5028990a",
  null
  
)

export default component.exports